import axios from 'axios';
import authHeader from "@/service/auth-header";

class CourseAssessmentService {

  processCourseModuleAssessment(userId, courseModuleId, data) {
    console.log("[CourseAssessmentService][processCourseModuleAssessment] Got into function. courseModuleId = ", courseModuleId);

    return axios.post(`/api/courseassessment/${userId}/${courseModuleId}`, data, {headers: authHeader()});
  }

}

export default new CourseAssessmentService();
